/* eslint-disable */
import { initialAbility } from "@/libs/acl/config";
import BaseService from "../../BaseService";

const { http } = BaseService();

// API

export function GetPagingParams(postdata) {
  const data = { ...postdata };
  return http({
    url: "Menu/get-paging-params",
    method: "post",
    data,
  });
}

export function GetAll() {
  return http({
    url: "Menu/get-all",
    method: "get",
  });
}

export function GetTree() {
  return http({
    url: "Menu/GetTree",
    method: "get",
  });
}
export function GetTreeList() {
  return http({
    url: "Menu/GetTreeList",
    method: "get",
  });
}

export function GetTreeAll() {
  return http({
    url: "Menu/GetTreeAll",
    method: "get",
  });
}

export function GetById(data) {
  return http({
    url: "Menu/get-by-id/" + data,
    method: "get",
  });
}

export function MenuCreate(postdata) {
  const data = { ...postdata };
  return http({
    url: "Menu/Create",
    method: "post",
    data,
  });
}

export function MenuUpdate(postdata) {
  const data = { ...postdata };
  return http({
    url: "Menu/Update",
    method: "post",
    data,
  });
}

export function MenuDelete(postdata) {
  // const data = { ...postdata };
  return http({
    url: "Menu/Delete/" + postdata,
    method: "post",
  });
}
